import BotoesDadosTabelaMixin from '@/produto/spa/planejamento-contrato/list/BotoesDadosTabelaMixin';

export default BotoesDadosTabelaMixin;
